import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../data/mock';
import { Star, Heart, Layers, Shield, Calendar, Users } from 'lucide-react';

const WhyChooseUs = () => {
  const { t } = useLanguage();
  const whyUsText = t(translations.whyUs);

  const iconMap = {
    star: Star,
    heart: Heart,
    layers: Layers,
    shield: Shield,
    calendar: Calendar,
    users: Users,
  };

  return (
    <div className="min-h-screen">
      {/* Page Header */}
      <section className="bg-gradient-to-r from-[#0B1F3F] to-[#1a3a5f] text-white py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="text-4xl md:text-5xl font-bold mb-4">{whyUsText.title}</h1>
          <p className="text-xl text-gray-200">{whyUsText.subtitle}</p>
        </div>
      </section>

      {/* Features Grid */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-6xl mx-auto">
            {whyUsText.features.map((feature, index) => {
              const IconComponent = iconMap[feature.icon] || Star;
              return (
                <div
                  key={index}
                  className="group p-8 bg-white rounded-2xl shadow-md border border-gray-100 hover:shadow-2xl hover:border-[#FF6B35] transition-all duration-300 hover:-translate-y-2"
                >
                  <div className="w-16 h-16 bg-gradient-to-br from-[#FF6B35] to-[#FF8A5B] rounded-2xl flex items-center justify-center mb-6 shadow-lg group-hover:scale-110 transition-transform duration-300">
                    <IconComponent className="h-8 w-8 text-white" />
                  </div>
                  <h3 className="text-2xl font-bold text-[#0B1F3F] mb-3">{feature.title}</h3>
                  <p className="text-gray-700 leading-relaxed">{feature.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </section>
    </div>
  );
};

export default WhyChooseUs;
